import { render, staticRenderFns } from "./uploader-dnd-area.vue?vue&type=template&id=c2de1914"
import script from "./uploader-dnd-area.vue?vue&type=script&lang=js"
export * from "./uploader-dnd-area.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports